import {ChangeDetectionStrategy, Component, DestroyRef, effect, input} from "@angular/core";
import {AkseptertSignaturmetode} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {TranslateModule} from "@ngx-translate/core";

type Skjema = SigneringVelgAksepterteMetoderKomponent['skjema'];
type SkjemaVerdier = Skjema['value'];

const debug = initDebugger('SigneringVelgAksepterteMetoderKomponent');

/**
 * Lar bruker velge hvilke signeringsmetoder som skal kunne benyttes
 */
@Component({
    selector: 'signering-velg-aksepterte-metoder',
    templateUrl: 'signering-velg-aksepterte-metoder.html',
    styleUrl: 'signering-velg-aksepterte-metoder.scss',
    host: {'data-testid': 'aksepterte-metoder'},
    imports: [
        MatSlideToggle,
        ReactiveFormsModule,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SigneringVelgAksepterteMetoderKomponent {

    skjemaKontroll = input.required<FormControl<AkseptertSignaturmetode[]>>();

    skjema = new FormGroup({
        enkel: new FormControl(false, {nonNullable: true}),
        avansert: new FormControl(false, {nonNullable: true}),
    });

    constructor(private destroyRef: DestroyRef) {
        //la verdier satt på skjemaKontroll blø ned til vårt eget skjema
        effect(() => {
            //sett ihht initielle verdier
            this.oppdaterLokaltSkjem(this.skjemaKontroll().value);
            //lytt så til senere endringer
            this.skjemaKontroll().valueChanges
                .pipe(takeUntilDestroyed(this.destroyRef),)
                .subscribe(nyVerdi => {
                    this.oppdaterLokaltSkjem(nyVerdi);
                })
        });

        //sørg for at endringer i vårt eget skjema blør ut til skjemaKontroll
        this.skjema.valueChanges
            .pipe(takeUntilDestroyed())
            .subscribe(valgteMetoder => this.oppdaterEksterntSkjema(valgteMetoder))
    }

    private oppdaterLokaltSkjem(valgteMetoder: AkseptertSignaturmetode[]) {
        this.skjema.patchValue({
            enkel: valgteMetoder.includes(AkseptertSignaturmetode.enkelelektronisk),
            avansert: valgteMetoder.includes(AkseptertSignaturmetode.avansertelektronisk)
        }, {emitEvent: false});
    }

    private oppdaterEksterntSkjema(valgteMetoder: SkjemaVerdier) {
        const signaturmetoder: AkseptertSignaturmetode[] = [];
        if (valgteMetoder.enkel) signaturmetoder.push(AkseptertSignaturmetode.enkelelektronisk);
        if (valgteMetoder.avansert) signaturmetoder.push(AkseptertSignaturmetode.avansertelektronisk);
        this.skjemaKontroll().setValue(signaturmetoder);
    }
}
